function run() {
  smoothScroll();
  readMore();
  figureParagraph();
  accordion();
  navigation();
  searchBar();
  signupPopup();
  languageSwitcher();
  anchorAttributes();

  // ip detecting the users country
  if(document.getElementById('login-popup') && localStorage.getItem('logged') !== 'true') {
    document.getElementById('login-popup').style.display = 'block';

    if (document.getElementById('rayaldee-link')) {
      document.getElementById('rayaldee-link').onclick = function() {
        // location.replace(document.getElementById('rayaldee-link').getAttribute('href'));
        window.location.href = document.getElementById('rayaldee-link').getAttribute('href');
      }
    }

    document.body.classList.add('disable-scroll-hcp');

    //userPermissionsCheck();
    routingBetweenModals();
    selectCheckbox();
    openCountriesList();
    selectACountry();
    docCheckActivation();
  }else{
    if(localStorage.getItem('swiss') && localStorage.getItem('swiss') === 'yes'){
      window.location.replace('ch-de/home');
      localStorage.setItem('swiss', 'no');
    }
  }

  // run when optin form exist
  if(document.querySelector("#opt-in form")) {
    // addLineBeforeTextFields();
    // showInputLabel();
    // setCountry();
    selectMethodMessage();
    openLanguageSwitcher();
    positionLanguageSwitcher();
    autoCheck();
  }
}

if (document.readyState !== 'loading') {
  run();
}// modern browsers
else if (document.addEventListener) {
  document.addEventListener(
      'DOMContentLoaded', run);
}// IE <= 8
else {
  document.attachEvent('onreadystatechange', function() {
    if (document.readyState === 'complete') {
      run();
    }
  });
}
